import React, { useState } from "react";
import { Section } from "./Elements/Section";
import { Card } from "./Elements/Card";
import { MapPin, Linkedin, Github } from "lucide-react";
import { COLOR_ACCENT, COLOR_PRIMARY } from "../config/Constants";
import { isEmail } from "../utils/helpers";
import { Button } from "./Elements/Button";
import { CardContent } from "./Elements/Card";

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({ email: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    if (name === "email") {
      setErrors((prev) => ({
        ...prev,
        email: value && !isEmail(value) ? "Please enter a valid email" : "",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isEmail(formData.email)) {
      setErrors((prev) => ({ ...prev, email: "Please enter a valid email" }));
      return;
    }
    // TODO: Wire up actual submission (email/webhook). For now, show success state.
    setSubmitted(true);
  };

  return (
    <Section
      id="contact"
      eyebrow="Let’s talk"
      title="Ready to build?"
      subtitle="Tell us about your goals. We’ll come back with a proposal within a week."
    >
      <div className="grid lg:grid-cols-3 gap-6">
        <Card>
          <div className="flex items-center gap-2 text-gray-800 font-semibold">
            <MapPin className="w-5 h-5" /> Offices
          </div>
          <p className="mt-2 text-sm text-gray-600">
            India · USA (remote‑first with client‑onsite options)
          </p>
          <div className="mt-4 flex items-center gap-4 text-sm text-gray-600">
            <a
              href="#"
              className="inline-flex items-center gap-2 hover:text-indigo-700"
            >
              <Linkedin className="w-4 h-4" style={{ color: COLOR_ACCENT }} />{" "}
              LinkedIn
            </a>
            <a
              href="#"
              className="inline-flex items-center gap-2 hover:text-indigo-700"
            >
              <Github className="w-4 h-4" style={{ color: COLOR_ACCENT }} />{" "}
              GitHub
            </a>
          </div>
        </Card>
      </div>

      <div className="mt-10 max-w-3xl">
        <Card className="shadow-lg">
          <CardContent>
            {submitted ? (
              <div
                className="rounded-xl p-4 text-sm"
                style={{
                  backgroundColor: `${COLOR_ACCENT}22`,
                  color: COLOR_PRIMARY,
                }}
              >
                Thanks! Your message has been sent. We’ll get back to you
                shortly.
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2"
                    style={{
                      borderColor: "#e5e7eb",
                      boxShadow: `0 0 0 2px transparent`,
                      outline: "none",
                    }}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="you@company.com"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2"
                    style={{
                      borderColor: errors.email ? "#ef4444" : "#e5e7eb",
                    }}
                    required
                  />
                  {errors.email && (
                    <p className="mt-2 text-sm" style={{ color: "#ef4444" }}>
                      {errors.email}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Message
                  </label>
                  <textarea
                    name="message"
                    placeholder="Tell us a bit about your project..."
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2"
                    style={{ borderColor: "#e5e7eb" }}
                    required
                  />
                </div>
                <Button
                  type="submit"
                  style={{ backgroundColor: COLOR_PRIMARY }}
                >
                  Send Message
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </Section>
  );
};
